export default __webpack_public_path__ + "static/media/lumen-dashboard-banner-1-mobile.a6fddd31.svg";